import { ChevronRight, ChevronLeft } from "lucide-react";

export default function BookingNavButtons({
  step,
  isLastStep,
  submitting,
  t,
  onBack,
  onNext,
  onSubmit,
}) {
  return (
    <div className="flex items-center justify-between mt-10">
      {step > 1 ? (
        <button
          onClick={onBack}
          className="inline-flex items-center gap-2 text-[var(--primary)] font-bold hover:text-[var(--primary-hover)] transition"
          data-testid="booking-back-btn"
        >
          <ChevronLeft className="w-5 h-5" />
          {t.booking.back}
        </button>
      ) : (
        <span />
      )}

      {isLastStep ? (
        <button
          onClick={onSubmit}
          disabled={submitting}
          className="btn-primary"
          data-testid="booking-submit-btn"
        >
          {submitting ? t.booking.submitting : t.booking.submit}
          {!submitting && <ChevronRight className="w-5 h-5" />}
        </button>
      ) : (
        <button onClick={onNext} className="btn-primary" data-testid="booking-next-btn">
          {t.booking.next}
          <ChevronRight className="w-5 h-5" />
        </button>
      )}
    </div>
  );
}
